import { render, staticRenderFns } from "./SkeletonEventCard.vue?vue&type=template&id=6ac7bf7f&scoped=true"
import script from "./SkeletonEventCard.vue?vue&type=script&lang=js"
export * from "./SkeletonEventCard.vue?vue&type=script&lang=js"
import style0 from "./SkeletonEventCard.vue?vue&type=style&index=0&id=6ac7bf7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac7bf7f",
  null
  
)

export default component.exports